import { object, number, string, array } from '@gogame/schemas';

import {
  FILTER_FILTERSTATUSES,
  FILTER_PARTNERS,
  FILTER_COUNTRIES,
  FILTER_APPLICATIONS,
  FILTER_ACCOUNTS,
  FILTER_CREATED_BY,
} from 'scenes/CustomAudiences/LookalikeAudiences/constants';

export const EMPTY_FILTERS = {};

const ACTIVE_FILTERSTATUS = 0;
const ERROR_FILTERSTATUS = 2;
const UPDATING_FILTERSTATUS = 3;

export const filtersSchema = object({
  [FILTER_FILTERSTATUSES]: array(number()),
  [FILTER_PARTNERS]: array(number()),
  [FILTER_COUNTRIES]: array(number()),
  [FILTER_APPLICATIONS]: array(number()),
  [FILTER_ACCOUNTS]: array(string()),
  [FILTER_CREATED_BY]: array(number()),
}).default({
  [FILTER_FILTERSTATUSES]: [
    ACTIVE_FILTERSTATUS,
    ERROR_FILTERSTATUS,
    UPDATING_FILTERSTATUS,
  ],
});
